import ResetPassword from "../features/Auth/Components/ResetPassword";
function ResetPasswordPage() {
    return(
        <div>
            <ResetPassword/>
            </div>
    )
}
export default ResetPasswordPage;